import React, { useState, useEffect } from "react";
import { Row, Col, Typography, List, Select, Card, Checkbox, Button } from "antd";
import { useHistory } from "react-router-dom";
import {
  primaryCountry,
  secondaryCountry,
  otherCountry,
  miliphoreCounties,
} from "../constants/app-constant";
import '../App.css'

const { Title, Paragraph } = Typography;

const CountrySelect = ({ isModal, handleOk }) => {
  let history = useHistory();
  if(localStorage.getItem("_country") && !isModal) {
    history.push('/login')
  }
  const setCountryToLocalStorage = (country) => {
    localStorage.setItem("_country", country);
  }

  const [_country, setCountry] = useState('');
  const [state, setState] = useState(false);
  const _onItemClick = (country) => {
    
    if(isModal) {
      if(country && miliphoreCounties.indexOf(country) !== -1) {
        setCountryToLocalStorage(country);
        handleOk()
      }
      setCountry(country);
    } else {
      if(country && miliphoreCounties.indexOf(country) !== -1) {
        setCountryToLocalStorage(country);
        history.push("/login");
      }
      setCountry(country);
      
    }
  };

  const updateCountryData = () => {
    setCountryToLocalStorage(_country);
    if(isModal) {
      handleOk()
    } else {
      history.push("/login");
    }
  }
  useEffect(() => {
    setCountry('')
  }, [])

  return (
    <>
      {!isModal && (
        <Row type="flex" style={{ "padding-top": isModal ? "10px" : "1rem" }}>
          <Col offset="2" span="12">
            <Title level={3} style={{ color: "#503291" }}>
              Location
            </Title>
          </Col>
        </Row>
      )}

      <Row
        type="flex"
        justify="center"
        gutter={[0, 8]}
        className="login-container"
      >
        <Col span={(isModal? 6 : 4)}>
          <Paragraph>
            <ul>
              {primaryCountry.map((n) => (
                <li>
                  <a onClick={() => _onItemClick(n.actual)}>{n.toShow}</a>
                </li>
              ))}
            </ul>
          </Paragraph>
          <Select
            showSearch
            defaultValue={otherCountry[0].actual}
            style={{ width: 200 }}
            placeholder="Other Location"
            optionFilterProp="children"
            onChange={(val) => _onItemClick(val)}
            onSearch={(q) => console.log("on search==" + q)}
          >
            {otherCountry.map((o, key) => (
              <Select.Option key={key} value={o.actual}>
                {o.toShow}
              </Select.Option>
            ))}
          </Select>
        </Col>
        <Col span={1}></Col>
        {secondaryCountry.map((list) => {
          return (
            <>
              <Col span={4}>
                <List
                  size="small"
                  dataSource={list}
                  renderItem={(item) => (
                    <List.Item onClick={() => _onItemClick(item.actual)}>
                      {item.toShow}
                    </List.Item>
                  )}
                />
              </Col>
              <Col span={1}></Col>
            </>
          );
        })}
        {
          _country && miliphoreCounties.indexOf(_country) === -1 && (
            <Col span={20}>
              <Card style={{ width: '100%' }}>
                <Row justify="center" align="middle">
                  <Col span={2} align="center" className="pt-10">
                  <Checkbox onClick={() => setState(!state)}/>
                  </Col>
                  <Col span={18}>
                    <span>
                      In the United States, Canada and Puerto Rico we operate as MilliporeSigma. Please confirm that you are not located in these countries and you intend to visit our sites outside these countries by checking the box to the left and clicking 'Continue'.
                    </span>
                  </Col>
                  <Col span={4} className="pt-10" align="center">
                    <Button type="primary" onClick={updateCountryData} disabled={!state}>Continue</Button>
                  </Col>
                </Row>
              </Card>
            </Col>
          )
        }
      </Row>
    </>
  );
};

export default CountrySelect;
